import { render } from "./SingleStockMovementItemForm.vue?vue&type=template&id=55c614c3"
import script from "./SingleStockMovementItemForm.vue?vue&type=script&lang=js"
export * from "./SingleStockMovementItemForm.vue?vue&type=script&lang=js"

import exportComponent from "/usr/local/var/www/duo_front/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__